<!-- 

  左上角面板：产业概况等

 -->
<template>
  <div>
    <!-- 第一部分：产业总览 -->
    <el-row :gutter="20">
      <el-col :span="6">
        <digi-flopper
          :items="[
            { name: '品牌价值', val: 102.2, unit: '亿元' },
            { name: '种植面积', val: 21.1, unit: '万亩' }
          ]"
        ></digi-flopper>
      </el-col>
      <el-col :span="6">
        <digi-flopper
          :items="[
            { name: '从业人员', val: 18, unit: '万人' },
            { name: '种植户', val: 8.2, unit: '万户' }
          ]"
        ></digi-flopper>
      </el-col>
      <el-col :span="6">
        <digi-flopper
          :items="[
            { name: '年产量', val: 35, unit: '万吨' },
            { name: '年产值', val: 108, unit: '亿元' }
          ]"
        ></digi-flopper>
      </el-col>
      <el-col :span="6">
        <digi-flopper
          :items="[
            { name: '亩均增收', val: 2.3, unit: '万元' },
            { name: '亩均利润', val: 1.8, unit: '万元' }
          ]"
        ></digi-flopper>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col>
        <div style="font-size: 15px; color: #9cd9fc">
          长丰县是我国著名的优质草莓生产基地，先后荣获“中国草莓之都”、“中国设施草莓第一县”、“国家地理标志商标”、“首批全国农业全产业链典型县”等八项国字号荣誉。其中“艳九天”、“蝶恋花”品牌荣获“全国十大好吃草莓”称号。
        </div>
      </el-col>
    </el-row>

    <!-- 种植 -->
    <el-row style="margin-top: 20px" :gutter="30">
      <el-col :span="15">
        <!-- 乡镇种植面积比例 -->
        <town-ratio></town-ratio>
        <!-- 乡镇企业数排名 -->
        <entity-amount-rank></entity-amount-rank>
      </el-col>
      <el-col :span="9">
        <!-- 企业种植面积排名 -->
        <corp-rank></corp-rank>
      </el-col>
    </el-row>

    <!-- 辐射、种苗 -->

    <el-row :gutter="10" style="padding: 10px">
      <el-col :span="12" style="color: #9cd9fc"> </el-col>
      <el-col :span="12" style="color: #9cd9fc"> </el-col>
    </el-row>
  </div>
</template>
<script>
import DigiFlopper from './digi-flopper.vue'
import CorpRank from './corp-rank'
import TownRatio from './town-ratio'
import EntityAmountRank from './entity-amount-rank.vue'

export default {
  components: {
    EntityAmountRank,
    DigiFlopper,
    CorpRank,
    TownRatio
  },
  data() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/screen28896/summary-zone/index.vue